import { render, staticRenderFns } from "./FaturamentoEvolucaoVolumeVendas3.vue?vue&type=template&id=6419fc78&scoped=true&"
import script from "./FaturamentoEvolucaoVolumeVendas3.vue?vue&type=script&lang=js&"
export * from "./FaturamentoEvolucaoVolumeVendas3.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoEvolucaoVolumeVendas3.vue?vue&type=style&index=0&id=6419fc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419fc78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
